import { DuviCoreAdminAppShell } from "../../components/duvi-core-admin-app-shell";
import { useDuviCoreAdminSupportTicketDetail } from "./use-duvi-core-admin-support-ticket-detail";
import { DuviCoreAdminSupportTicketDetailView } from "./duvi-core-admin-support-ticket-detail-view";

export function DuviCoreAdminSupportTicketDetail() {
  const state = useDuviCoreAdminSupportTicketDetail();
  const label = state.ticket
    ? `#${state.ticket.ticket_id}`
    : `#${state.id ?? ""}`;

  return (
    <DuviCoreAdminAppShell
      title={state.ticket?.subject ?? label}
      subtitle="Conversation and actions"
      breadcrumbs={["Support", "Tickets", label]}
      headerBreadcrumbs={[
        { label: "Support", href: "/support/tickets" },
        { label },
      ]}
      activeMenuItem="Support"
    >
      <DuviCoreAdminSupportTicketDetailView {...state} />
    </DuviCoreAdminAppShell>
  );
}
